import React from "react";
import "./DistributorForm.css";
import { useForm } from "react-hook-form";
import axiosPrivate from "../../../hooks/axiosPrivate";
import { showErrorToast } from "../../../Toster";
import LoaderContext from "../../../context/Loader/LoaderContext";
import { useContext } from "react";
import { successToast, errorToast } from "../../backend/common/Toaster";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../custom-button";
const DistributorForm = () => {
  const { setLoaderCheck } = useContext(LoaderContext);

  const formSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    mobile: Yup.string()
      .test(
        "starts-not-with-0-to-5",
        "Please enter a valid phone number",
        function (value) {
          // Check if the mobile number does not start from 0 to 5
          if (!value) return true; // If no value, let Yup.string().required handle it
          return !/^[0-5]/.test(value);
        }
      )
      .required("Phone number is required"),
    email: Yup.string()
      .matches(
        /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid Email!"
      )
      .required("Email is required"),
    city: Yup.string().required("Village/City is required"),
    taluka: Yup.string().required("Taluka/Tehsil is required"),
    district: Yup.string().required("District is required"),
    state: Yup.string().required("State is required"),
    // message: Yup.string().required("Message is required"),
    sell_platform: Yup.string().required("Sell Platform is required"),
  });

  const formValues = {
    name: "",
    mobile: "",
    email: "",
    city: "",
    taluka: "",
    district: "",
    state: "",
    message: "",
    sell_platform: "",
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    errors,
    touched,
  } = useFormik({
    initialValues: formValues,
    validationSchema: formSchema,
    onSubmit: (data, { resetForm }) => {
      data.form_type = "distributor";
      setLoaderCheck(true);
      axiosPrivate
        .post("/contact-us", data)
        .then((res) => {
          setLoaderCheck(false);

          resetForm();
          successToast("Form Submitted Successfully!");
        })
        .catch((error) => {
          setLoaderCheck(false);
          successToast("Something Went Wrong!");
          if (typeof error.response.data.errors == "array") {
            successToast(error.response.data.errors[0].msg);
          } else {
            successToast(error.response.data.errors.msg);
          }
        });
    },
  });

  const numberFilter = (event) => {
    const inputValue = event.target.value;

    const numericValue = inputValue.replace(/\D/g, "");
    setFieldValue(event.target.name, numericValue);
  };

  const nameFilter = (event) => {
    const inputValue = event.target.value;
    if (/^[A-Za-z\s'-]+$/.test(inputValue) || inputValue === "") {
      setFieldValue(event.target.name, inputValue);
    }
  };

  return (
    <form className="formWrapper" onSubmit={handleSubmit}>
      <div className="formWrapperHeader">
        <h2>Distributor Form</h2>
        <p>
          You can join our network of dynamic partners and unlock new
          opportunities for growth and success!
        </p>
      </div>
      <div className="formWrapperContent">
        {/* Name and Mobile */}
        <div className="formWrapperRow">
          <div className="formWrapperCol">
            <label htmlFor="name" className="formWrapperLabel">
              Name<span className="formWrapperError">*</span>
            </label>
            <input
              type="text"
              className="formWrapperInput"
              name="name"
              id="name"
              onChange={(event) => {
                nameFilter(event);
              }}
              onBlur={handleBlur}
              value={values.name}
            />
            {touched.name && errors.name ? (
              <div className="formWrapperError">{errors.name}</div>
            ) : null}
          </div>
          <div className="formWrapperCol">
            <label htmlFor="mobile" className="formWrapperLabel">
              Phone Number<span className="formWrapperError">*</span>
            </label>
            <input
              type="text"
              className=" formWrapperInput"
              name="mobile"
              id="mobile"
              onChange={(event) => {
                numberFilter(event);
              }}
              onBlur={handleBlur}
              value={values.mobile}
              maxLength={10}
            />
            {touched.mobile && errors.mobile ? (
              <div className="formWrapperError">{errors.mobile}</div>
            ) : null}
          </div>
        </div>
        {/* Email and City */}
        <div className="formWrapperRow">
          <div className="formWrapperCol">
            <label htmlFor="email" className="formWrapperLabel">
              Email Address<span className="formWrapperError">*</span>
            </label>
            <input
              type="email"
              className="formWrapperInput"
              name="email"
              id="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
            />
            {touched.email && errors.email ? (
              <div className="formWrapperError">{errors.email}</div>
            ) : null}
          </div>
          <div className="formWrapperCol">
            <label htmlFor="city" className="formWrapperLabel">
              Village/City<span className="formWrapperError">*</span>
            </label>
            <input
              type="text"
              className=" formWrapperInput"
              name="city"
              id="city"
              onChange={(event) => {
                nameFilter(event);
              }}
              onBlur={handleBlur}
              value={values.city}
            />
            {touched.city && errors.city ? (
              <div className="formWrapperError">{errors.city}</div>
            ) : null}
          </div>
        </div>
        {/* Taluka and District */}
        <div className="formWrapperRow">
          <div className="formWrapperCol">
            <label htmlFor="taluka" className="formWrapperLabel">
              Taluka/Tehsil<span className="formWrapperError">*</span>
            </label>

            <input
              type="text"
              className=" formWrapperInput"
              name="taluka"
              id="taluka"
              onChange={(event) => {
                nameFilter(event);
              }}
              onBlur={handleBlur}
              value={values.taluka}
            />
            {touched.taluka && errors.taluka ? (
              <div className="formWrapperError">{errors.taluka}</div>
            ) : null}
          </div>
          <div className="formWrapperCol">
            <label htmlFor="district" className="formWrapperLabel">
              District<span className="formWrapperError">*</span>
            </label>
            <input
              type="text"
              className="formWrapperInput"
              name="district"
              id="district"
              onChange={(event) => {
                nameFilter(event);
              }}
              onBlur={handleBlur}
              value={values.district}
            />
            {touched.district && errors.district ? (
              <div className="formWrapperError">{errors.district}</div>
            ) : null}
          </div>
        </div>
        {/* State and how sell minfert product*/}
        <div className="formWrapperRow">
          <div className="formWrapperCol">
            <label htmlFor="state" className="formWrapperLabel">
              State<span className="formWrapperError">*</span>
            </label>
            <input
              type="text"
              className="formWrapperInput"
              name="state"
              id="state"
              onChange={(event) => {
                nameFilter(event);
              }}
              onBlur={handleBlur}
              value={values.state}
            />
            {touched.state && errors.state ? (
              <div className="formWrapperError">{errors.state}</div>
            ) : null}
          </div>
          <div className="formWrapperCol">
            <label className="formWrapperLabel">
              How will you sell Minfert Products
              <span className="formWrapperError">*</span>
            </label>
            <div className="formWrapperRadioGroupWrapper">
              <div className="formWrapperRadioGroup">
                <input
                  type="radio"
                  className="formWrapperRadio"
                  id="online"
                  name="sell_platform"
                  value="online"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                <label className="formWrapperRadioLabel" htmlFor="online">
                  On-line
                </label>
              </div>
              <div className="formWrapperRadioGroup">
                <input
                  type="radio"
                  className="formWrapperRadio"
                  name="sell_platform"
                  id="inStore"
                  value="inStore"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <label className="formWrapperRadioLabel" htmlFor="inStore">
                  In-Store
                </label>
              </div>
              <div className="formWrapperRadioGroup">
                <input
                  type="radio"
                  className="formWrapperRadio"
                  name="sell_platform"
                  id="other"
                  value="other"
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                <label className="formWrapperRadioLabel" htmlFor="other">
                  Other
                </label>
              </div>
            </div>
            {touched.sell_platform && errors.sell_platform ? (
              <div className="formWrapperError">{errors.sell_platform}</div>
            ) : null}
          </div>
        </div>
        {/* Message */}
        <div className="formWrapperRow">
          <div className="formWrapperCol">
            <label className="formWrapperLabel" htmlFor="message">
              Subject/Message
            </label>
            <textarea
              className="formWrapperTextarea"
              name="message"
              id="message"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.message}
            />
          </div>
        </div>
      </div>
      <div className="formWrapperFooter">
        <CustomButton type={"submit"} text={"Submit"} className="mb-0" />
      </div>
    </form>
  );
};

export default React.memo(DistributorForm); // Memoize the DistributorForm;
